import { render, staticRenderFns } from "./top-logs.vue?vue&type=template&id=84b11726&scoped=true"
import script from "./top-logs.vue?vue&type=script&lang=js"
export * from "./top-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b11726",
  null
  
)

export default component.exports